import { render } from "./portfolio-overview.vue?vue&type=template&id=ceaa71ac&scoped=true&ts=true"
import script from "./portfolio-overview.vue?vue&type=script&lang=ts"
export * from "./portfolio-overview.vue?vue&type=script&lang=ts"

import "./portfolio-overview.vue?vue&type=style&index=0&id=ceaa71ac&scoped=true&lang=scss"

import exportComponent from "/Users/reevoengineering/Projects/reevo/propbank/propbank-brochure-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceaa71ac"]])

export default __exports__